import { createGlobalStyle } from 'styled-components';

import { INavigationTheme } from 'styles/theme/navigation';
import { ITheme } from 'styles/theme';

interface IGlobalStyles extends ITheme {
  navigation: INavigationTheme;
}

export default createGlobalStyle<{ theme: IGlobalStyles; cdnAssetPrefix: string }>`
  * {
    box-sizing: border-box;
  }

  html,
  body {
    padding: 0;
    margin: 0;
    max-width: 100%;
    min-height: 100vh;

    font-family: 'GOATProductVariableVF', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
      Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;;
    font-size: 11.5px;
    line-height: 16px;
    font-variation-settings: 'slnt' 0;
    
    -webkit-font-smoothing: antialiased;

    @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
      font-size: 11.5px;
      line-height: 14px;
    }

    background: ${({ theme }) => theme.navigation.backgroundColor};
    color:  ${({ theme }) => theme.navigation.textColor};
  }

  #__next {
    position: relative;
    height: 100vh;
  }

  .forceShowMobileNav {
    height: 100%;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    touch-action: none;
  }

  .forceWhiteBackground {
    background-color: #FFFFFF;
  }

  .hideOverflowX {
    overflow-x: hidden;
  }

  img {
    max-width: 100%;
    display: block;
  }

  nav li::before {
  content: none;
  }

  button {
    background-color: transparent;
    border: none;

    :focus:not(:focus-visible) {
      outline: none;
    }

    :active {
      outline: none;
      border: none;
    }
  }

  a {
    cursor: pointer;
    color: inherit;

    :focus:not(:focus-visible) {
      outline: none;
    }

    :active,
    :hover {
      color: inherit;
      text-decoration: none;
    }
  }

  @font-face {
    font-family: 'GOATProductVariableVF';
    src:
      url(${({ cdnAssetPrefix }) =>
        cdnAssetPrefix
          ? `${cdnAssetPrefix}/public/fonts/GOATProductVariableVF.woff2`
          : '/fonts/GOATProductVariableVF.woff2'}) format('woff2'),
      url(${({ cdnAssetPrefix }) =>
        cdnAssetPrefix
          ? `${cdnAssetPrefix}/public/fonts/GOATProductVariableVF.woff`
          : '/fonts/GOATProductVariableVF.woff'}) format('woff');
    font-style: 400;
    font-weight: normal;
    font-display: swap;
  }

    @font-face {
     font-family: 'GOATProductVariableVF-Bold';
     src:
       url(${({ cdnAssetPrefix }) =>
         cdnAssetPrefix
           ? `${cdnAssetPrefix}/public/fonts/GOATProductVariableVF.woff2`
           : '/fonts/GOATProductVariableVF.woff2'}) format('woff2'),
       url(${({ cdnAssetPrefix }) =>
         cdnAssetPrefix
           ? `${cdnAssetPrefix}/public/fonts/GOATProductVariableVF.woff`
           : '/fonts/GOATProductVariableVF.woff'}) format('woff');
     font-style: normal;
     font-weight: 700;
     font-display: swap;
   }
`;
